import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnderline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconUnderline"><Path d="M7 3.5C7 3.22386 6.77614 3 6.5 3C6.22386 3 6 3.22386 6 3.5V12.0345C6 15.8025 8.61352 19 12 19C15.3865 19 18 15.8025 18 12.0345V3.5C18 3.22386 17.7761 3 17.5 3C17.2239 3 17 3.22386 17 3.5V12.0345C17 15.408 14.6886 18 12 18C9.31135 18 7 15.408 7 12.0345V3.5Z" fill="currentColor"/><Path d="M5.5 20C5.22386 20 5 20.2239 5 20.5C5 20.7761 5.22386 21 5.5 21H18.5C18.7761 21 19 20.7761 19 20.5C19 20.2239 18.7761 20 18.5 20H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnderline;
